import React, { Component } from 'react';
import '../App.css';
import '../styles/employees.css';
import Fade from 'react-reveal/Fade';
import { HashLink as Link } from 'react-router-hash-link';

import employeesBannerImage from '../assets/for-employees/Panel-Employees-Card.svg';

import oneIcon from '../assets/for-employers/number-one.svg';
import twoIcon from '../assets/for-employers/number-two.svg';
import threeIcon from '../assets/for-employers/number-three.svg';
import fourIcon from '../assets/for-employers/number-four.svg';

// why choose sole graphics //

import forEmployees1 from '../assets/for-employees/Why-one.svg';
import forEmployees2 from '../assets/for-employees/Why-two.svg';
import forEmployees3 from '../assets/for-employees/Why-three.svg';
import forEmployees4 from '../assets/for-employees/Why-four.svg';

import mobileAppGraphic from '../assets/for-employees/home-banner-app.svg';

class CardholderExperience extends Component {

  constructor(props) {
    super(props);
    this.pauseAutoplay = this.pauseAutoplay.bind(this);
    this.pauseAutoplayForSecondSlider = this.pauseAutoplayForSecondSlider.bind(this);
  }

  pauseAutoplay() {
    this.slider.slickPause();
  }

  pauseAutoplayForSecondSlider() {
    this.slider2.slickPause();
  }

  render() {

    return (
      <section id="cardholder-experience-section">
        <div id="for-employees-section-1">
          <div className="banner-text section-title-text-wrapper">
              <p className="section-header">
              DO IT FOR YOUR EMPLOYEES
              </p>
              <p className="section-body">
                Help pave their way to financial freedom.
              </p>
            </div>
            <img className="banner-image" src={employeesBannerImage} alt={''} />
            <div className="down-button-container">
              <Link to={`/slides#for-employees-section-2`}
                className="down-button-background">
                <i className="fa fa-angle-down" />
              </Link>
            </div>
        </div>
        <div id="for-employees-section-2">
        <Fade bottom>
          <div className="section-title-text-wrapper">
              <p className="section-header">
                WHY CHOOSE FINTWIST<br />FOR YOUR EMPLOYEES
              </p>
              <p>
                Great question! Here are just a few reasons:
              </p>
          </div>
          </Fade>
          <div id="why-choose-for-employees-content-wrapper">
            <Fade bottom cascade>
              <div className="why-choose-sole-image-and-text-wrapper">
                <img className="why-sole-graphic" src={forEmployees1} alt={''} />
                <div className="how-it-works-step">
                  <img src={oneIcon} alt={""} />
                  <p>Save Them Time<br />and Money</p>
                  <p className="section-body">Paycards are 80% less expensive than check-cashing services and allow your employees to pay bills online instead of in person.</p>
                </div>
              </div>
              <div className="why-choose-sole-image-and-text-wrapper">
                <img className="why-sole-graphic" src={forEmployees2} alt={''} />
                <div className="how-it-works-step">
                  <img src={twoIcon} alt={""} />
                  <p>Endless<br />Education</p>
                  <p className="section-body">Your employees will receive emails and ads with how-to videos and blog posts, ongoing educational campaigns, and knowledgeable customer service.</p>
                </div>
              </div>
              <div className="why-choose-sole-image-and-text-wrapper">
                <img className="why-sole-graphic" src={forEmployees3} alt={''} />
                <div className="how-it-works-step">
                  <img src={threeIcon} alt={""} />
                  <p>Access to Modern<br />Conveniences</p>
                  <p className="section-body">You’ll give your employees a way to access Netflix, Lyft, Venmo, online shopping, travel planning tools like buying a plane ticket, and more!</p>
                </div>
              </div>
              <div className="why-choose-sole-image-and-text-wrapper">
                <img className="why-sole-graphic" src={forEmployees4} alt={''} />
                <div className="how-it-works-step">
                  <img src={fourIcon} alt={""} />
                  <p>24/7 Phone<br />Support</p>
                  <p className="section-body">Your employees’ questions will never go unanswered with our 24/7 bilingual phone support.</p>
                  <Link to={`/contact`}><button>Let's get started!</button></Link>
                </div>
              </div>
              </Fade>
          </div>
        </div>
        <div id="for-employees-section-4">
          <Fade bottom>
              <div className="section-title-text-wrapper">
                <p className="section-header">
                  NEW APP.<br />NEW FEATURES.
                </p>
                <p>
                  The Fintwist Payroll Card app is the easiest way for your employees to manage their money.
                </p>
              <Fade bottom cascade>
                <Link to={`/demo`}>
                  <button>View the interactive demo</button>
                </Link>
                </Fade>
              </div>
              <img src={mobileAppGraphic} alt={''} />
            </Fade>
          </div>
        {/* <div id="for-employees-section-5">
          <Fade bottom>
            <img src={swipeSmarter} alt={''} />
            <div className="section-title-text-wrapper">
              <p className="section-header">
                REWARD YOUR<br />EMPLOYEES
              </p>
              <p>
                We reward your employees just for using their card. Each month, we give away $1,000 to a cardholder who swiped their card as credit 15 or more times in the last month.
              </p>
              <Link to={`/contact`}>
                <button>Find out more!</button>
              </Link>
            </div>
          </Fade>
        </div> */}
      </section>
    );
  }
}

export default CardholderExperience;
